export const formatArrayToMultipleWordsSeparatedByComma = (
  words: string[],
): string => {
  const phrase = words.join(', ')

  const lastIndexOfComma = phrase.lastIndexOf(',')
  console.log({ lastIndexOfComma })

  if (lastIndexOfComma === -1) return phrase

  return `${phrase.substring(0, lastIndexOfComma)} e ${phrase.substring(
    lastIndexOfComma + 1,
  )}`
}

export function capitalizeFirstLetter(string) {
  if (!string) return ''
  return string?.toLowerCase()?.replace(/\b\w/g, match => match?.toUpperCase())
}

export function pluralizeWord(
  singularWord: string,
  pluralWord: string,
  lengthToCheck: number,
) {
  return lengthToCheck > 1 ? pluralWord : singularWord
}
